import { render, staticRenderFns } from "./IntractSnackbar.vue?vue&type=template&id=61c3ed90"
import script from "./IntractSnackbar.vue?vue&type=script&lang=js"
export * from "./IntractSnackbar.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports